import * as trace from 'owa-trace';
import { logUsage } from 'owa-analytics';
import { DatapointVariant } from 'owa-analytics-actions';
import {
    createTimeStreamProject,
    deleteTimeStreamProject,
    getLoadingProjectsFailure,
    loadingProjectsFailed,
} from 'owa-timestream-store';
import type { NewOutlookSpace, NewOutlookSpaceAsset } from 'owa-timestream-types';
import { setDefaultBoardCreationState } from '../mutators/defaultBoardCreationStateMutators';
import { OutlookCalendarAppName } from '../constants';
import { DefaultBoardCreationState } from '../schema';
import didLoadingCalendarBoardProjectFail from '../selectors/didLoadingCalendarBoardProjectFail';
import getDefaultBoardProject from '../selectors/getDefaultBoardProject';
import getDefaultBoardCreationState from '../selectors/getDefaultBoardCreationState';
import loc from 'owa-localize';
import { calendarBoardDefaultProjectName } from './CalendarBoardProject.locstring.json';

export async function createDefaultBoardProject(assets: NewOutlookSpaceAsset[]) {
    try {
        setDefaultBoardCreationState(DefaultBoardCreationState.Creating);
        const defaultBoardProject: NewOutlookSpace = {
            name: loc(calendarBoardDefaultProjectName),
            appName: OutlookCalendarAppName,
            assets,
        };

        await createTimeStreamProject('' /* targetMailbox */, defaultBoardProject);
        setDefaultBoardCreationState(DefaultBoardCreationState.SuccessCreateNew);
    } catch (e) {
        trace.errorThatWillCauseAlert('Failed to create board project', e);
        setDefaultBoardCreationState(DefaultBoardCreationState.ErrorCreateNew);
    }
}

export function deleteCalendarBoardDefaultProject() {
    try {
        const project = getDefaultBoardProject();
        if (project) {
            deleteTimeStreamProject(project.projectId);
            setDefaultBoardCreationState(DefaultBoardCreationState.NotStarted);
        }
    } catch (error) {
        trace.debugErrorThatWillShowErrorPopupOnly('Failed to delete board project', error);
    }
}

export function logDefaultCalendarBoardLoadState() {
    const creationState = getDefaultBoardCreationState();
    const errorMessage = didLoadingCalendarBoardProjectFail() ? getLoadingProjectsFailure() : '';
    // if default board creation state is "Not Started", that means the board already existed, check
    // owa-timestream-store if there was a problem with the getOutlookSpaces service call (for any space, since it's made as a group)
    const loadState =
        creationState != DefaultBoardCreationState.NotStarted
            ? creationState
            : loadingProjectsFailed()
            ? 'Error load existing'
            : 'Success load existing';
    logUsage(
        'DefaultBoardLoadState',
        {
            loadState_1: loadState,
            loadFailureError_2: errorMessage,
        },
        {
            variant: DatapointVariant.WarmOnly,
        }
    );
}
